
const ConceptSection = () => {
  return (
    <section className="py-20 lg:py-32 bg-white px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="rounded-3xl overflow-hidden shadow-xl w-full h-[500px]">
              <img
                src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/d8a98eb46111bb35dcebdd8ca84c4ef9.png"
                alt="患者様と向き合う医師"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <span className="text-[#007bbb] text-xs font-semibold tracking-widest uppercase">CONCEPT</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-4 mb-8">
              診療コンセプト
            </h2>
            
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p>
                おかやま整形外科は、2000年の開院以来、岡山市北区を中心とした地域の皆様の健康をサポートしてまいりました。私たちは「痛みに寄り添い、動ける喜びを取り戻す」という理念のもと、患者様一人ひとりに最適な医療を提供することを使命としています。
              </p>
              <p>
                整形外科の診療において最も大切なことは、患者様の声に耳を傾け、痛みや不安を理解することだと考えています。症状の原因を正確に診断し、わかりやすく説明することで、患者様が安心して治療に臨めるよう心がけています。
              </p>
              <p>
                最新の医療機器と豊富な診療実績を活かし、スポーツ障害から高齢者の関節痛まで、幅広い症状に対応いたします。リハビリテーションにも力を入れており、患者様が日常生活に早く復帰できるよう、きめ細やかなサポートを行っています。
              </p>
              <p>
                地域の皆様に信頼され、愛されるクリニックであり続けるため、スタッフ一同、日々研鑽を積み、質の高い医療サービスの提供に努めてまいります。
              </p>
            </div>

            <div className="mt-8">
              <div className="w-20 h-1 bg-[#007bbb] rounded-full"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConceptSection;
